<template>
  <div class="policy-summary-card" :aria-label="`根据文章详情，提炼核心内容：${title}`">
    <strong class="policy-summary-heading">根据文章详情，提炼核心内容</strong>
    <div class="policy-summary-title" :title="title">{{ title || '政策详情' }}</div>
    <div class="policy-summary-preview" aria-hidden="true">
      <div ref="previewContent" class="policy-summary-lines" :class="{ 'is-scrolling': scrollSteps > 0 }" :style="scrollStyle">{{ previewText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PolicySummaryQuestion',
  props: {
    title: { type: String, default: '' },
    preview: { type: String, default: '' },
  },
  data() {
    return { scrollSteps: 0 };
  },
  computed: {
    previewText() {
      return this.preview.replace(/\s+/g, ' ').trim() || '文章内容已发送';
    },
    scrollStyle() {
      return {
        '--scan-distance': `${-this.scrollSteps * 22}px`,
        '--scan-steps': Math.max(1, this.scrollSteps),
        '--scan-duration': `${Math.max(1, this.scrollSteps * 0.16)}s`,
      };
    },
  },
  watch: {
    preview() {
      this.$nextTick(this.updateScrollSteps);
    },
  },
  mounted() {
    this.updateScrollSteps();
    // 按实际宽度换行，保证正文能一直滚动到最后一行。
    if (typeof ResizeObserver !== 'undefined') {
      this.previewObserver = new ResizeObserver(this.updateScrollSteps);
      this.previewObserver.observe(this.$refs.previewContent);
    } else {
      window.addEventListener('resize', this.updateScrollSteps);
    }
  },
  beforeDestroy() {
    if (this.previewObserver) this.previewObserver.disconnect();
    window.removeEventListener('resize', this.updateScrollSteps);
  },
  methods: {
    updateScrollSteps() {
      const content = this.$refs.previewContent;
      if (!content) return;
      this.scrollSteps = Math.max(0, Math.round(content.scrollHeight / 22) - 1);
    },
  },
};
</script>

<style scoped>
.policy-summary-card {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 12px 14px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.85);
  border-radius: 14px 14px 4px 14px;
  background:
    radial-gradient(ellipse at 95% 10%, rgba(190, 164, 255, 0.48), transparent 65%),
    radial-gradient(ellipse at 5% 100%, rgba(122, 222, 233, 0.4), transparent 65%),
    linear-gradient(120deg, rgba(228, 239, 255, 0.85), rgba(244, 232, 255, 0.8));
  box-shadow: 0 4px 16px rgba(91, 106, 175, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.8);
  -webkit-backdrop-filter: blur(16px) saturate(150%);
  backdrop-filter: blur(16px) saturate(150%);
  text-align: left;
}
.policy-summary-heading {
  display: block;
  overflow: hidden;
  color: #36447b;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.policy-summary-title,
.policy-summary-preview {
  height: 22px;
  overflow: hidden;
  color: #647096;
  font-size: 13px;
  font-weight: 400;
  line-height: 22px;
}
.policy-summary-title {
  color: #465781;
  font-weight: 500;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.policy-summary-lines {
  white-space: normal;
  overflow-wrap: anywhere;
}
.policy-summary-lines.is-scrolling {
  animation: policy-summary-scan var(--scan-duration) steps(var(--scan-steps), end) forwards;
}
@keyframes policy-summary-scan {
  from { transform: translateY(0); }
  to { transform: translateY(var(--scan-distance)); }
}
@media (prefers-reduced-motion: reduce) {
  .policy-summary-lines.is-scrolling {
    animation: none;
    transform: translateY(var(--scan-distance));
  }
}
</style>
